"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorVerticalSeparation = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var mobx_1 = require("mobx");
var image_button_1 = require("../../../components/button/image.button");
var icons_1 = require("../../../components/icon/icons");
var menu_item_style_1 = require("../../../components/menu/menu.item.style");
var theme_1 = require("../../../components/theme");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var form_field_editor_height_1 = require("./form.field.editor.height");
var CSS = {
    container: 'c-FdcVertSep',
    title: 'c-FdcVertSep__title',
    list: 'c-FdcVertSep__list',
    menu: 'c-FdcVertSep__menu',
    menuContainer: 'c-FdcVertSep__menuContainer',
    option: 'c-FdcVertSep__option',
    value: 'c-FdcVertSep__value',
    ghost: 'c-FdcVertSep__ghost',
    icon: {
        icon: 'c-FdcVertSep__icon',
        label: 'c-FdcVertSep__icon-label'
    },
    unit: 'c-FdcVertSep__unit',
    selected: 'c-FdcVertSep__selected',
    input: 'c-Input__input',
    MDL: {
        input: 'mdl-textfield__input'
    }
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.container] = {
        width: '100%',
        display: 'flex',
        'flex-direction': 'column'
    },
    _a[CSS.list] = {
        display: 'flex',
        width: '100%',
        'align-items': 'center'
    },
    _a[CSS.title] = {
        'font-weight': 'bold',
        'margin-bottom': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[CSS.option] = {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center'
    },
    _a[CSS.selected] = {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center'
    },
    _a[CSS.ghost] = {
        color: theme_1.DefaultTheme.font.color.supporting
    },
    _a[CSS.value] = {
        width: '150px',
        'text-align': 'left'
    },
    _a[CSS.unit] = {
        'font-weight': 700,
        'margin-left': '4px'
    },
    _a[CSS.icon.icon] = {
        margin: '0 4px',
        'font-style': 'normal'
    },
    _a[CSS.icon.label] = {
        'border-radius': '50%',
        border: '1px solid ' + theme_1.DefaultTheme.background.grey,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'font-weight': 'bold',
        'font-size': '12px',
        height: '16px',
        width: '16px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        margin: '0 8px'
    },
    _a[CSS.menu] = (_b = {},
        _b["& .".concat(menu_item_style_1.CSS.item)] = {
            'padding-top': theme_1.DefaultTheme.space(1),
            'padding-bottom': theme_1.DefaultTheme.space(1),
            'line-height': theme_1.DefaultTheme.space(6)
        },
        _b),
    _a[CSS.menuContainer] = {
        display: 'flex',
        position: 'relative',
        'align-items': 'center'
    },
    _a));
var FormFieldEditorVerticalSeparation = /** @class */ (function (_super) {
    tslib_1.__extends(FormFieldEditorVerticalSeparation, _super);
    function FormFieldEditorVerticalSeparation(designer, field) {
        return _super.call(this, designer, field) || this;
    }
    FormFieldEditorVerticalSeparation.prototype.getClearanceNode = function () {
        var _this = this;
        this.clearanceField = { clearance: this.field.clearanceThresholdInMeters !== null ? Math.round(core_shared_1.IkeUnit.convert(this.field.clearanceThresholdInMeters, services_1.Services.UserSettings.units === 'meters' ? core_shared_1.IkeUnit.CENTIMETER : core_shared_1.IkeUnit.INCH, core_shared_1.IkeUnit.METER)) : null };
        return (0, mithril_1.m)('div', { className: CSS.container }, [
            (0, mithril_1.m)('div', { className: "".concat(CSS.option, " ").concat(CSS.title) }, 'Clearance Threshold (optional)'),
            (0, mithril_1.m)('div', { className: CSS.menuContainer }, [
                (0, mithril_1.m)('input', {
                    className: "".concat(CSS.input, " ").concat(CSS.MDL.input, " ").concat(CSS.value), type: 'number', placeholder: "Clearance in ".concat(services_1.Services.UserSettings.units === 'meters' ? 'cm' : 'inches'),
                    value: this.clearanceField.clearance,
                    oninput: function (e) { return _this.changeClearance({ clearance: parseFloat(e.target.value) }); }
                }),
                (0, mithril_1.m)('sup', { className: "".concat(CSS.unit) }, services_1.Services.UserSettings.units === 'meters' ? 'cm' : 'inches'),
                image_button_1.ImageButton.view(icons_1.MaterialIcon.DELETE, {
                    onclick: function () {
                        _this.setClearanceThresholdInMeters(null);
                    }
                })
            ])
        ]);
    };
    //default view
    FormFieldEditorVerticalSeparation.prototype.viewInfoRW = function () {
        var node = (0, mithril_1.m)('div', { className: CSS.list }, [
            this.getLabelWithNode(),
            this.getClearanceNode()
        ]);
        return node;
    };
    FormFieldEditorVerticalSeparation.prototype.changeClearance = function (key) {
        var clearanceInMeters = 0;
        if (key.clearance !== null) {
            clearanceInMeters = core_shared_1.IkeUnit.convert(key.clearance, core_shared_1.IkeUnit.METER, services_1.Services.UserSettings.units === 'meters' ? core_shared_1.IkeUnit.CENTIMETER : core_shared_1.IkeUnit.INCH);
        }
        this.setClearanceThresholdInMeters(clearanceInMeters);
        this.clearanceField = key;
    };
    tslib_1.__decorate([
        mobx_1.action.bound
    ], FormFieldEditorVerticalSeparation.prototype, "changeClearance", null);
    return FormFieldEditorVerticalSeparation;
}(form_field_editor_height_1.FormFieldEditorHeight));
exports.FormFieldEditorVerticalSeparation = FormFieldEditorVerticalSeparation;
//# sourceMappingURL=form.field.editor.vertical.separation.js.map